// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import OnlinkButton from 'Ui/components/common/onlink-button';
import {joinClassNames} from 'Utils/html-utils';
import {IconAdd} from '@deere/icons';
import MediaQuery, {MOBILE_MEDIA_QUERY} from 'Ui/components/higher-order-components/media-query';

function AddButton(props) {
    const {isMobile} = props;

    const btnWrapperStyle = isMobile ? {
        position: 'absolute',
        bottom: '32px'
    } : null;

    const startIcon = isMobile ? null : <IconAdd/>;

    const variant = isMobile ? 'borderless' : 'primary';

    return (
        <div
            className='extra-table-options right-aligned'
            style={btnWrapperStyle}
        >
            <OnlinkButton
                className={joinClassNames(props.className, 'primary')}
                disabled={props.disabled}
                onClick={props.onClick}
                startIcon={startIcon}
                variant={variant}
            >
                {props.label}
            </OnlinkButton>
        </div>
    );
}

AddButton.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    isMobile: PropTypes.bool,
    label: PropTypes.string,
    onClick: PropTypes.func
};

export default MediaQuery(MOBILE_MEDIA_QUERY)(AddButton);
